<template>
  <!-- 自定义实现menu，不使用el-menu -->
  <div class="menu-container">
    <div class="menu" v-for="item in routes" :key="item.path">
      <div class="menu-item_one" :class="{ 'is-active': isPathPrefix(item.path) }" v-if="item.children?.length == 0">
        <LinkItem :to="item.path" class="menu-item-title">
          <SvgIcon v-if="item.meta?.svgIcon" :name="item.meta?.svgIcon as string" class="icon" />
          <span>{{ item.meta?.title }}</span>
        </LinkItem>
      </div>
      <el-popover
        v-else
        placement="bottom"
        :width="750"
        popper-class="tooltip"
        :hide-after="100"
        transition="el-zoom-in-top"
        :show-arrow="false"
      >
        <template #reference>
          <div :class="{ 'is-active': isPathPrefix(item.path) }" class="menu-item_more menu-item-title">
            <SvgIcon v-if="item.meta?.svgIcon" :name="item.meta?.svgIcon as string" class="icon" />
            <span>{{ item.meta?.title }}</span>
            <SvgIcon name="arraw" class="icon-arraw" />
          </div>
        </template>
        <SubMenu :menu="item"></SubMenu>
      </el-popover>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SubMenu from './SubMenu.vue';
import { computed } from 'vue';

const route = useRoute();
const routes = nestRoutes();
const activeMenu = computed(() => {
  const {
    meta: { activeMenu },
    path,
  } = route;
  return activeMenu ? activeMenu : path;
});

const isPathPrefix = (path2: string) => {
  const path1 = activeMenu.value as string;
  const p1 = path1.split('/');
  const p2 = path2.split('/');
  return p2?.every((val, index) => val === p1[index]);
};

const realPath = (left: string, right: string) => {
  if (left.endsWith('/') && right.startsWith('/')) {
    return left + right.slice(1);
  } else if (!left.endsWith('/') && !right.startsWith('/')) {
    return left + '/' + right;
  } else {
    return left + right;
  }
};
// console.log(activeMenu.value);
</script>

<style lang="scss" scoped>
.menu-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .menu {
    .menu-item_one {
      margin: 0px 5px;
      border-radius: 3px;
      line-height: 20px;
      &:hover {
        background-color: var(--hover-bg-color);
        cursor: pointer;
      }

      &:has(> .router-link-active) {
        background-color: var(--hover-bg-color);
      }
    }

    .menu-item_more {
      margin: 0px 5px;
      border-radius: 3px;
      line-height: 20px;
      &:hover {
        background-color: var(--hover-bg-color);
        cursor: pointer;

        .icon-arraw {
          transform: rotateX(180deg);
        }
      }
    }

    .menu-item-title {
      display: flex;
      align-items: center;
      position: relative;
      color: rgba(0, 0, 0, 1);
      padding: 5px 15px;
      .icon {
        vertical-align: middle;
        min-width: 1em;
        margin-right: 8px;
        font-size: 18px;
        line-height: 30px;
      }
      span {
        vertical-align: middle;
      }
      .icon-arraw {
        margin-left: 5px;
        font-size: 18px;
        transition: transform 0.5s;
        transform-origin: center 58%;
      }
    }
  }
}
.is-active {
  background-color: var(--hover-bg-color);
  cursor: pointer;
}
</style>
